import React, { useCallback, useMemo, useState } from "react";
import { NavLink, useHistory } from "react-router-dom";
import { app, apiRoot } from "../../index";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import styled from "styled-components";
import ValidPasswordInput from "../layout/ValidPasswordInput";
import axios from "axios";

export default function Register() {
  const history = useHistory();
  const [step, setStep] = useState(1);
  const [formError, setFormError] = useState([]);
  const [formData, setFormData] = useState({
    selectedPlan: "solo",
    email: "",
    password: "",
    confirmPassword: "",
    name: "",
    siren: "",
    revtc: "",
    owner: "",
    tel: "",
    country: "",
    city: "",
    zip: "",
    adresse: "",
    vat_number: "",
  });

  function nextStep() {
    if (step === 1 && !handleStep1Validation(true)) return;

    setStep((old) => old + 1);
  }

  function prevStep() {
    setFormError([]);
    setStep((old) => old - 1);
  }

  function handleChange(e) {
    const { name, value } = e.target;
    setFormData((old) => ({
      ...old,
      [name]: value,
    }));
  }

  function handleSelectChange(e) {
    setFormData((old) => ({
      ...old,
      selectedPlan: e.target.value,
    }));
  }

  let onPasswordChange = useCallback((newPassword) => {
    setFormData((old) => ({
      ...old,
      password: newPassword,
    }));
  }, []);

  function handleStep1Validation(reset = true) {
    const { email, password, confirmPassword } = formData;
    let valid = true;
    let message = [];
    if (reset) setFormError([]);

    if (email.trim() === "") {
      valid = false;
      message.push("Veuillez saisir une adresse mail");
    }
    if (password.trim() === "") {
      valid = false;
      message.push("Veuillez saisir un mot de passe");
    }
    if (password !== confirmPassword) {
      valid = false;
      message.push("Les mots de passe ne correspondent pas.");
    }

    setFormError((old) => [...old, ...message]);
    return valid;
  }

  function handleStep2Validation(reset = true) {
    const { name, city, zip, country, siren, adresse, tel, owner, vat_number } =
      formData;
    let valid = true;
    let message = [];

    if (reset) setFormError([]);

    if (!name?.trim()) {
      valid = false;
      message.push("Veuillez saisir le nom de votre société");
    }
    if (!owner?.trim()) {
      valid = false;
      message.push("Veuillez saisir le nom du gérant");
    }
    if (!siren?.trim()) {
      valid = false;
      message.push("Veuillez saisir le SIREN");
    }
    if (!vat_number?.trim()) {
      valid = false;
      message.push("Veuillez saisir le numéro de TVA");
    }
    if (!tel?.trim()) {
      valid = false;
      message.push("Veuillez saisir le téléphone");
    }
    if (!country?.trim()) {
      valid = false;
      message.push("Veuillez saisir le pays");
    }
    if (!city?.trim()) {
      valid = false;
      message.push("Veuillez saisir la ville");
    }
    if (!zip?.trim()) {
      valid = false;
      message.push("Veuillez saisir le code postal");
    }
    if (!adresse?.trim()) {
      valid = false;
      message.push("Veuillez saisir l'adresse");
    }

    setFormError((old) => [...old, ...message]);
    return valid;
  }

  function handleValidation() {
    let valid = true;

    if (!handleStep1Validation(true)) valid = false;
    if (!handleStep2Validation(false)) valid = false;

    return valid;
  }

  async function handleFormSubmit(e) {
    e.preventDefault();
    if (handleValidation()) {
      const {
        email,
        password,
        name,
        selectedPlan,
        city,
        zip,
        country,
        siren,
        revtc,
        adresse,
        tel,
        owner,
        vat_number,
      } = formData;
      try {
        await axios.post(apiRoot + "/api/v1/auth/register", {
          email,
          password,
          name,
          selectedPlan,
          city,
          zip,
          country,
          siren,
          revtc,
          adresse,
          tel,
          owner,
          vat_number,
        });

        // Sign in user after successful registration
        await app.auth().signInWithEmailAndPassword(email, password);

        history.push("/");
      } catch (error) {
        console.error(error);
        setFormError([error.message]);
      }
    }
  }

  const FormAlert = useMemo(() => {
    if (!formError.length) return null;
    return (
      <div
        className="alert alert-danger"
        role="alert"
        style={{ flexDirection: "column" }}
      >
        {formError.map((error, index) => (
          <div
            className="alert-text"
            key={index}
            style={{ alignSelf: "flex-start" }}
          >
            {error}
          </div>
        ))}
      </div>
    );
  }, [formError]);

  return (
    <Container className="auth-bg">
      <div className="d-flex align-items-center justify-content-center w-100">
        <div className="row justify-content-center w-100 my-5 my-xl-0">
          <div className="col-md-9 d-flex flex-column justify-content-center">
            <div className="card mb-0 bg-body auth-login m-auto w-100">
              <div className="row gx-0">
                <div className="col-xl-6 border-end">
                  <div className="row justify-content-center py-4">
                    <div className="col-lg-11">
                      <div className="card-body">
                        <a
                          href="https://zeplan.ai/"
                          className="text-nowrap logo-img d-block mb-4 w-100"
                        >
                          <img
                            src="https://zeplan.ai/wp-content/uploads/2024/04/Document-size-Black.png"
                            className="dark-logo"
                            alt="Logo-Dark"
                            style={{ width: "150px" }}
                          />
                        </a>
                        <h2 className="lh-base mb-4">
                          Inscrivez-vous à ZEPLAN
                        </h2>
                        <form onSubmit={handleFormSubmit}>
                          {FormAlert}

                          {step === 1 && (
                            <>
                              <div className="mb-3">
                                <label htmlFor="email" className="form-label">
                                  Adresse Email
                                </label>
                                <input
                                  type="email"
                                  className="form-control"
                                  placeholder="Email"
                                  name="email"
                                  autoComplete="off"
                                  onChange={handleChange}
                                  value={formData.email}
                                  style={{
                                    background: "rgb(109, 98, 141, 12%)",
                                  }}
                                />
                              </div>
                              <div className="mb-4">
                                <label
                                  htmlFor="password"
                                  className="form-label"
                                >
                                  Mot de Passe
                                </label>
                                <ValidPasswordInput
                                  password={formData.password}
                                  setPassword={onPasswordChange}
                                />
                              </div>
                              <div className="mb-4">
                                <label
                                  htmlFor="confirmPassword"
                                  className="form-label"
                                >
                                  Confirmer le mot de passe
                                </label>
                                <input
                                  type="password"
                                  className="form-control"
                                  placeholder="Confirmer le mot de passe"
                                  name="confirmPassword"
                                  value={formData.confirmPassword}
                                  onChange={handleChange}
                                  style={{
                                    background: "rgb(109, 98, 141, 12%)",
                                  }}
                                />
                              </div>
                              <div className="mb-3">
                                <input
                                  type="radio"
                                  id="solo"
                                  name="selectedPlan"
                                  value="solo"
                                  checked={formData.selectedPlan === "solo"}
                                  onChange={handleSelectChange}
                                />
                                <label htmlFor="solo" className="ms-2">
                                  Je suis chauffeur indépendant
                                </label>
                              </div>
                              <div className="mb-4">
                                <input
                                  type="radio"
                                  id="company"
                                  name="selectedPlan"
                                  value="company"
                                  checked={formData.selectedPlan === "company"}
                                  onChange={handleSelectChange}
                                />
                                <label htmlFor="company" className="ms-2">
                                  J'ai plusieurs chauffeurs
                                </label>
                              </div>
                              <div className="mb-4 d-flex align-items-start">
                                <input
                                  className="mt-1"
                                  type="checkbox"
                                  id="cgu"
                                  checked={formData.cgu}
                                  onChange={(e) => {
                                    e.preventDefault();
                                    const checked = e.target.checked;
                                    setFormData((old) => ({
                                      ...old,
                                      cgu: checked,
                                    }));
                                  }}
                                />
                                <label htmlFor="cgu" className="ms-2">
                                  Je confirme avoir pris connaissance et accepté
                                  les{" "}
                                  <a
                                    href="https://zeplan.ai/informations-legales/cgu/"
                                    rel="noreferrer"
                                    target="_blank"
                                  >
                                    CGU
                                  </a>{" "}
                                  et la{" "}
                                  <a
                                    href="https://zeplan.ai/informations-legales/politique-de-confidentialite/"
                                    rel="noreferrer"
                                    target="_blank"
                                  >
                                    Politique de Confidentialité
                                  </a>
                                  .
                                </label>
                              </div>
                              <button
                                type="button"
                                className="btn btn-dark w-100 py-8 mb-4 rounded-1"
                                disabled={!formData.cgu}
                                onClick={nextStep}
                              >
                                Suivant
                              </button>
                            </>
                          )}
                          {step === 2 && (
                            <>
                              <div className="mb-3">
                                <label
                                  htmlFor="companyName"
                                  className="form-label"
                                >
                                  Nom de la compagnie
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Nom de la compagnie"
                                  name="name"
                                  value={formData.name}
                                  onChange={handleChange}
                                  style={{
                                    background: "rgb(109, 98, 141, 12%)",
                                  }}
                                />
                              </div>
                              <div className="mb-4">
                                <label htmlFor="owner" className="form-label">
                                  Propriétaire
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Propriétaire"
                                  name="owner"
                                  value={formData.owner}
                                  onChange={handleChange}
                                  style={{
                                    background: "rgb(109, 98, 141, 12%)",
                                  }}
                                />
                              </div>
                              <div className="mb-3">
                                <label htmlFor="siren" className="form-label">
                                  SIREN
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="SIREN"
                                  name="siren"
                                  value={formData.siren}
                                  onChange={handleChange}
                                  style={{
                                    background: "rgb(109, 98, 141, 12%)",
                                  }}
                                />
                              </div>
                              <div className="mb-3">
                                <label htmlFor="revtc" className="form-label">
                                  REVTC
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Numéro REVTC"
                                  name="revtc"
                                  value={formData.revtc}
                                  onChange={handleChange}
                                  inputMode="numeric"
                                  style={{
                                    background: "rgb(109, 98, 141, 12%)",
                                  }}
                                />
                              </div>
                              <div className="mb-3">
                                <label
                                  htmlFor="vat_number"
                                  className="form-label"
                                >
                                  Numéro de TVA
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Numéro de TVA"
                                  name="vat_number"
                                  value={formData.vat_number}
                                  onChange={handleChange}
                                  style={{
                                    background: "rgb(109, 98, 141, 12%)",
                                  }}
                                />
                              </div>
                              <div className="mb-3">
                                <label htmlFor="tel" className="form-label">
                                  Téléphone
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Téléphone"
                                  name="tel"
                                  value={formData.tel}
                                  onChange={handleChange}
                                  style={{
                                    background: "rgb(109, 98, 141, 12%)",
                                  }}
                                />
                              </div>
                              <div className="mb-3">
                                <label htmlFor="country" className="form-label">
                                  Pays
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Pays"
                                  name="country"
                                  value={formData.country}
                                  onChange={handleChange}
                                  style={{
                                    background: "rgb(109, 98, 141, 12%)",
                                  }}
                                />
                              </div>
                              <div className="d-flex column-gap-2 flex-wrap">
                                <div className="mb-3 flex-grow-1">
                                  <label htmlFor="city" className="form-label">
                                    Ville
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Ville"
                                    name="city"
                                    value={formData.city}
                                    onChange={handleChange}
                                    style={{
                                      background: "rgb(109, 98, 141, 12%)",
                                    }}
                                  />
                                </div>
                                <div
                                  className="mb-3"
                                  style={{ maxWidth: "120px" }}
                                >
                                  <label htmlFor="zip" className="form-label">
                                    Code Postal
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Code Postal"
                                    name="zip"
                                    value={formData.zip}
                                    onChange={handleChange}
                                    style={{
                                      background: "rgb(109, 98, 141, 12%)",
                                    }}
                                  />
                                </div>
                              </div>
                              <div className="mb-3">
                                <label htmlFor="adresse" className="form-label">
                                  Adresse
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Adresse"
                                  name="adresse"
                                  value={formData.adresse}
                                  onChange={handleChange}
                                  style={{
                                    background: "rgb(109, 98, 141, 12%)",
                                  }}
                                />
                              </div>
                              <button
                                type="submit"
                                className="btn btn-dark w-100 py-8 mb-4 rounded-1"
                              >
                                S'inscrire
                              </button>
                              <button
                                type="button"
                                className="btn w-100 py-8 mb-4 rounded-1"
                                onClick={prevStep}
                              >
                                Précédent
                              </button>
                            </>
                          )}
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xl-6 d-none d-xl-flex">
                  <div className="d-flex flex-column p-10 w-100">
                    <RightPane className="d-flex flex-column my-auto">
                      <h4>30 jours d'essai gratuit ! 🚀</h4>
                      <h5>Sans engagement - Aucune carte de crédit requise</h5>
                      <p>
                        Avec Zeplan, pilotez votre activité VTC depuis une
                        interface unique : gestion de vos clients et chauffeurs,
                        création de devis et réservations, facturation et
                        paiements intégrés. Grâce à l'IA, gagnez un temps
                        précieux et concentrez-vous sur ce qui compte vraiment :
                        vos clients.
                      </p>
                    </RightPane>
                  </div>
                </div>
              </div>
              <div className="text-center">
                <p className="mb-0">
                  Déjà inscrit ?{" "}
                  <NavLink to="/login" className="text-primary fw-bold">
                    Connexion
                  </NavLink>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
}

const Container = styled.div`
  display: grid;
  place-items: center;
  overflow: auto;
  min-height: 100vh;
`;

const RightPane = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: 1.25em;

  h4 {
    font-weight: bold;
    font-size: 1.5rem;
  }

  h5 {
    font-size: 1.1rem;
    font-weight: bold;
  }

  p {
    font-size: 1.05rem;
  }

  * {
    text-align: center;
  }
`;
